import type { Property as EdgeCrmProperty } from 'bundles/crm/properties/types';
import type { LeaseComp, Property as ResearchIndexProperty, SaleComp } from 'bundles/research/index/properties/types';

export function convertToEdgeCrmProperty(property: ResearchIndexProperty): EdgeCrmProperty {
  // Comps/properties are used kind of interchangeably in the research indexes
  // TODO: Tighten up types across properties/comps indexes instead of being wishy washy
  const isLeaseComp = property.type === 'Research::Lease';
  const isSaleComp = property.type === 'Research::Sale';

  let buildingSizeLabel = property.size;
  if (isLeaseComp) {
    const leaseComp = property as LeaseComp;
    buildingSizeLabel = leaseComp.sizeLabel;
  } else if (isSaleComp) {
    const saleComp = property as SaleComp;
    buildingSizeLabel = saleComp.buildingSizeLabel;
  } else {
    buildingSizeLabel = property.size;
  }

  return {
    ...property,
    buildingSizeLabel,
    dealStatusLabel: (isLeaseComp || isSaleComp) ? undefined : property.type,
    path: property.showPath,
    propertyTypeLabel: property.propertyType,
  };
}
